/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mapping_System_ZendeskInputs */

const en_mapping_system_zendesk = /** @type {(inputs: Mapping_System_ZendeskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zendesk`)
};

/**
* | output |
* | --- |
* | "Zendesk" |
*
* @param {Mapping_System_ZendeskInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const mapping_system_zendesk = /** @type {((inputs?: Mapping_System_ZendeskInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mapping_System_ZendeskInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_mapping_system_zendesk(inputs)
});